import { Autocomplete, Backdrop, Box, Checkbox, CircularProgress, FormHelperText, ListItemText, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, TextField, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as constants from "../../../constants";
import { RootState } from "../../../store/store";
import basestyle from "../../CSS/Base.module.css";
import { default as CancelPopUp, default as MappingDetailsWarningPopUp } from "../../PopUp/PopUp";
import { getBudgetActualEligibleMonthsByParticipantId, getForecastMappingDetailsByFinancialYearAndParticipantId, getForecastMappingDetailsByFinancialYearsAndParticipantId, getParticipantFileMappingByParticipantIdType } from "../services/Financials/budget.service";
import { EligibleMonthsVO } from "../services/Financials/financials";
import { getAllParticipants } from "../services/MonthlyCalculations/monthlyServices";
import { SectionTitle, StyledInputLabel, StyledOneChildContainer, StyledParentContainer, StyledTwoChildContainer, SubSectionTitle } from "../StyledComponents/Container";

import { AxiosError } from "axios";
import React from "react";
import * as XLSX from "xlsx";
import CustomAutocomplete from "../../../shared/AutoComplete";
import ContainedButton from "../../../shared/Button/CustomContainedButton";
import OutlinedButton from "../../../shared/Button/customOutlinedButton";
import CustomPopper from "../../../shared/CustomPopper";
import CustomTextField from "../../../shared/CustomTextFeild";
import { StyledTable } from "../../../shared/ReusableTable/TableStyle";
import { resetImportDataDetails, setImportDataDetails } from "../../../store/Financials/importDataSlice";
import CommonUtilities from "../Utils/CommonUtilities";
import FileUpload from "../Utils/FileUpload";
import { formatCurrency, formatCurrencywithoutDoller } from "../Utils/formatUtils";

import { postParticipantFileMapping } from "../services/Financials/actuals.service";
import { ParticipantsFileColumnMappingsVO } from "../services/Financials/financials";
import { notifyUser } from "../Utils/notifyUser";
import { fontSize, height } from "@mui/system";


interface FileInfo {
    name: string;
    size: number;
    type: string;
    file: File;
}

interface PeriodOption {
    id: number;
    value: string;
    name: string;
}
const defaultSelectOption = {
    forecastSubChartId: null,
    displayName: constants.SELECT_PLACEHOLDER,
    type: '',
    subChartAccountNumber: ''
};


const ActualsImport = () => {
    const dispatch = useDispatch();
    const { state } = useLocation();
    const navigate = useNavigate();
    const importData = useSelector((state: RootState) => state.importData);
    const [openPopUp, setOpenPopUp] = useState(false);
    const [fileChanged, setFileChanged] = useState(false);
    const [openMappingDetailsPopUp, setOpenMappingDetailsPopUp] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingFlag, setLoadingFlag] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [yearError, setYearError] = useState(false);
    const [periodError, setPeriodError] = useState(false);
    const [monthError, setMonthError] = useState(false);
    const [quarterError, setQuarterError] = useState(false);
    const [mappingDetailsFlag, setMappingDetailsFlag] = useState(false);
    const [fileColumnMappingId, setFileColumnMappingId] = useState(importData?.fileColumnMappingDetailes?.id ?? 0);
    const [availableMonths, setAvailableMonths] = useState<string[]>([]);
    const [semiannuallyError, setSemiannuallyError] = useState(false);
    const [yearlyTypeError, setYearlyTypeError] = useState(false);
    const [rowData, setRowData] = useState<any[]>(importData?.rowData ?? []);
    const [forecastMappingDetails, setForecastMappingDetails] = useState<string[]>(importData?.forecastMappingDetails ?? []);
    const [budgetYearsList, setBudgetYearsList] = useState<string[]>([]);
    const [period, setPeriod] = useState<PeriodOption | null>(importData?.period ?? null);
    const [month, setMonth] = useState<PeriodOption | null>(importData?.month ?? null);
    const [year, setYear] = useState(importData?.year ?? "");
    const [quarter, setQuarter] = useState<PeriodOption | null>(importData?.quarter ?? null);
    const [semiannually, setSemiannually] = useState<PeriodOption | null>(importData?.semiannually ?? null);
    const [yearlyType, setYearlyType] = useState<PeriodOption | null>(importData?.yearlyType ?? null);
    const [descriptionColumn, setDescriptionColumn] = useState<{ id: number; name: string }[]>(importData?.descriptionColumn ?? []);
    const [sheets, setSheets] = useState<string[]>(importData?.sheets ?? []);
    const [descriptionColumnList, setDescriptionColumnList] = useState<{ id: number; name: string }[]>(importData?.descriptionColumnList ?? []);
    const [amountColumnList, setAmountColumnList] = useState<string[]>(importData?.amountColumnList ?? []);
    const [eligibleList, setEligibleList] = useState<EligibleListItem[]>([]);
    const [periods, setPeriods] = useState<{ value: string; name: string }[]>([]);
    const [standardChartList, setStandardChartList] = useState([]);
    const [selectSheet, setSelectSheet] = useState(importData?.selectSheet ?? "");
    const [amountColumn, setAmountColumn] = useState(importData?.amountColumn ?? "");
    const [participantId, setParticipantId] = useState(0);
    const [monthCount, setMonthCount] = useState(0);
    const [file, setFile] = useState<any>(null);
    const [selectedFile, setSelectedFile] = useState(importData?.selectedFile ?? null);
    const userDetails = useSelector((state: RootState) => state.auth);
    const [amountColumnError, setAmountColumnError] = useState("");
    const [fileErrorMessage, setFileErrorMessage] = useState("");
    const [amountColumnErrors, setAmountColumnErrors] = useState<{ [key: string]: string }>({});
    const AdminProfile = useSelector((state: RootState) => state.participantAdminProfile);
    const [version, setVersion] = useState<number | null>(null);

    interface EligibleListItem {
        eligibleMonthsList: EligibleMonthsVO[];
        year: string;
    }
    const [participantArray, setParticipantArray] = useState<Participant[]>();
    interface Participant {
        participantId: number;
        participantName: string;
    }
    const [transformedImport, setTransformedImport] = useState<any[]>(importData?.transformedImport ?? []);
    const [selectedParticipant, setSelectedParticipant] = useState<Participant | null>({ participantId: 0, participantName: constants.SELECT_PLACEHOLDER });
    const months = CommonUtilities.monthsOrderListOptions;
    const monthOrder = CommonUtilities.monthOrderList;
    const monthOrderOptions = CommonUtilities.monthsOrderListOptions;
    const semiannuallys = CommonUtilities.semiannuallyOptions;
    const yearlyTypes = CommonUtilities.yearlyTypeOptions;
    const quarters = CommonUtilities.quarterOptions;
    const [amounts, setAmounts] = useState(importData?.amounts ?? "");
    const { t } = useTranslation();
    const translate = t as (key: string) => string;
    const [filteredQuarters, setFilteredQuarters] = useState<PeriodOption[]>([]);
    const [filteredMonthsList, setFilteredMonthsList] = useState<string[]>(importData?.filteredMonthsList ?? []);

    const [filteredSemiannuallys, setFilteredSemiannuallys] = useState<PeriodOption[]>([]);
    const [filteredYearlyTypes, setFilteredYearlyTypes] = useState<PeriodOption[]>([]);
    const SELECT_ALL_OPTION = { id: '0', name: 'Select All' };
    const mergedOptions = [SELECT_ALL_OPTION, ...descriptionColumnList];
    const columnName = CommonUtilities.columnName;
    const [columns, setColumns] = useState<any[]>([]);
    const getFiscalYearMonths = (fy: string) => {
        if (!fy.startsWith("FY")) return [];

        const endYear = 2000 + parseInt(fy.slice(2));
        const startYear = endYear - 1;

        return [
            { name: "Jul", year: startYear },
            { name: "Aug", year: startYear },
            { name: "Sep", year: startYear },
            { name: "Oct", year: startYear },
            { name: "Nov", year: startYear },
            { name: "Dec", year: startYear },
            { name: "Jan", year: endYear },
            { name: "Feb", year: endYear },
            { name: "Mar", year: endYear },
            { name: "Apr", year: endYear },
            { name: "May", year: endYear },
            { name: "Jun", year: endYear },
        ].map((month) => ({
            id: month.name,
            label: `${month.name} ${month.year}`,
            minWidth: 120,
        }));
    };

    const handleDioceseGLMappingChange = (index: number, newValue: any) => {
        const updatedData = [...transformedImport];
        updatedData[index] = {
            ...updatedData[index],
            dioceseGLMapping:
                newValue?.forecastSubChartId === null ? null : newValue,
        };
        setTransformedImport(updatedData);
    };

    const handleForecastChange = (fieldId: string, value: string, rowIndex: number) => {
        const updatedTransformed = [...transformedImport];
        const currentRow = { ...updatedTransformed[rowIndex], [fieldId]: value };
        const monthKeys = filteredMonthsList ?? [];
        let total = 0;
        for (const month of monthKeys) {
            const raw = month === fieldId ? value : currentRow[month] ?? "0";
            const numeric = parseFloat(raw.toString().replace(/[^0-9.-]+/g, "")) || 0;
            total += numeric;
        }

        currentRow.amount = formatCurrency(total);
        updatedTransformed[rowIndex] = currentRow;

        setTransformedImport(updatedTransformed);
    };

    const handleForecastBlur = (month: string, value: any, rowIndex: number) => {
    };

    useEffect(() => {
        let filteredMonths = [...monthOrder];
        if (period) {
            switch (period.value) {
                case "MONTHLY":
                    if (month) {
                        const selectedMonth = monthOrder.find((q) => q === month.value);
                        if (selectedMonth) {
                            filteredMonths = filteredMonths.filter((monthObj: any) => selectedMonth.includes(monthObj));
                        }
                    }
                    break;

                case "QUARTERLY":
                    if (quarter) {
                        const selectedQuarter = quarters.find((q) => q.value === quarter.value);
                        if (selectedQuarter) {
                            let monthNames = selectedQuarter.name.split(" ")[1].split("-");
                            const startIdx = monthOrder.indexOf(monthNames[0]);
                            const endIdx = monthOrder.indexOf(monthNames[monthNames.length - 1]);
                            if (startIdx !== -1 && endIdx !== -1) {
                                monthNames = monthOrder.slice(startIdx, endIdx + 1);
                            }
                            filteredMonths = filteredMonths.filter((monthObj) => monthNames.includes(monthObj));
                        }
                    }
                    break;

                case "SEMIANNUALLY":
                    if (semiannually) {
                        const selectedSemiannually = semiannuallys.find(q => q.value === semiannually.value);
                        if (selectedSemiannually) {
                            let monthNames = selectedSemiannually.name.split("-");
                            const startIdx = monthOrder.indexOf(monthNames[0]);
                            const endIdx = monthOrder.indexOf(monthNames[1]);
                            if (startIdx !== -1 && endIdx !== -1) {
                                const selectedMonths = monthOrder.slice(startIdx, endIdx + 1);
                                filteredMonths = filteredMonths.filter(monthObj => selectedMonths.includes(monthObj));
                            }
                        }
                    }
                    break;

                default:
                    break;
            }
        }


        const newColumns = [
            { id: "locationGL", label: translate('locationGL'), minWidth: 140, align: "left" },
            { id: "amount", label: translate('amount'), minWidth: 120, align: "right" },
            ...filteredMonths.map((monthObj) => {
                const fiscalYearMonths = getFiscalYearMonths(year);
                const matchedMonth = fiscalYearMonths.find(m => m.id === monthObj);
                return {
                    id: monthObj,
                    label: matchedMonth ? ` ${matchedMonth.label}` : monthObj,
                    minWidth: 120,
                };
            }),
            { id: "dioceseGLMapping", label: translate('dioceseGLMapping'), minWidth: 250, align: "center" },
        ];

        setColumns(newColumns);
        setFilteredMonthsList(filteredMonths)
        setMonthCount(filteredMonths.length);
    }, [period, quarter, semiannually, yearlyType, month, year]);



    const onchangeAmount = (newValue: any) => {
        setAmountColumnError("");
        if (!newValue || !amountColumnList.includes(newValue)) {
            setAmountColumnError(translate('pleaseSelectAValidAmountColumn'));
            return;
        }
        setAmountColumn(newValue);
    };
    const handleAmountChange = (monthId: number, newValue: string) => {
        setAmounts((prevAmounts) => ({
            ...prevAmounts,
            [monthId]: newValue,
        }));
    };
    async function saveParticipantFileMapping(): Promise<number | null> {
        const descriptionColumnsString = descriptionColumn
            .map((item: { name: string }) => item.name).join(",");

        let formate =
            yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES
                ? constants.YEARLY_TYPE_MONTHLY_VALUES_MONTHLY
                : constants.YEARLY_TYPE_ANNUAL;

        const participantsFileColumnMappingsVO: ParticipantsFileColumnMappingsVO = {
            id: importData?.fileColumnMappingDetailes?.id ? importData.fileColumnMappingDetailes?.id : 0,
            participantId: participantId,
            fileType: constants.TYPE_ACTUAL,
            formatType: formate,
            descriptionColumns: descriptionColumnsString,
            amountColumn:
                yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES
                    ? Object.values(amounts).join(",")
                    : amountColumn,
            isActive: constants.IS_ACTIVE_YES,
            version: importData?.fileColumnMappingDetailes?.version ? importData.fileColumnMappingDetailes?.version : 0,
            clientId: userDetails.clientId,
        };

        try {
            const responseList = await postParticipantFileMapping(participantsFileColumnMappingsVO);

            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                const fileColumnMappingDetailes = responseList.data?.data?.participantsFileColumnMappingsVOList[0];
                setFileColumnMappingId(fileColumnMappingDetailes?.id ?? 0);
                dispatch(
                    setImportDataDetails({
                        ...importData,
                        fileColumnMappingDetailes: fileColumnMappingDetailes,
                    })
                );

                return fileColumnMappingDetailes || null;
            } else {
                notifyUser(
                    responseList?.data?.message,
                    "error",
                    translate("actualsImport")
                );
                return null;
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(
                    translate("axiosError"),
                    error.response?.data ?? error.message
                );
            } else {
                console.error(translate("unexpectedError"), error);
            }

            notifyUser(
                constants.ERROR_VALIDATION_MESSAGE_ERROR_OCCURRED_WHILE_POSTING_THE_EXCEL_SHEET_DETAILES,
                "error",
                translate("actualsImport")
            );

            return null;
        } finally {
            setLoadingFlag(false);
            setMappingDetailsFlag(false);
        }
    }
    const handleContinue = async () => {
        const checkDuplicateDisplayNames = (data: any) => {
            const displayNames = new Map();
            let duplicateFound = false;
            data.forEach((item: any) => {
                if (item.dioceseGLMapping) {
                    const displayName = item.dioceseGLMapping.displayName;
                    if (displayNames.has(displayName)) {
                        displayNames.set(displayName, displayNames.get(displayName) + 1);
                    } else {
                        displayNames.set(displayName, 1);
                    }
                }
            });
            displayNames.forEach((count, displayName) => {
                if (count > 1) {
                    duplicateFound = true;
                    setOpenMappingDetailsPopUp(true);
                }
            });

            return duplicateFound;
        };

        const hasDuplicates = checkDuplicateDisplayNames(transformedImport);
        if (!hasDuplicates) {

            handleMappingDetailsConfirm();
        }
    };

    const handleMappingDetailsConfirm = async () => {
        setOpenMappingDetailsPopUp(false);
        let latestDetailes = importData?.fileColumnMappingDetailes;
        if (mappingDetailsFlag) {
            const fileMappingDetails = await saveParticipantFileMapping();
            latestDetailes = fileMappingDetails || importData?.fileColumnMappingDetailes;
        }
        dispatch(setImportDataDetails({
            participantId,
            listingPageType: "actualsListing",
            isInitialRender: false,
            rowData,
            quarter,
            period,
            semiannually,
            month,
            yearlyType,
            year,
            selectSheet,
            selectedFile,
            sheets,
            descriptionColumnList,
            amountColumnList,
            amountColumn,
            amounts,
            descriptionColumn,
            transformedImport,
            forecastMappingDetails,
            fileColumnMappingDetailes: latestDetailes,
        }));
        navigate("/actualsImported", { state: { version: version } });
    };

    useEffect(() => {
        setParticipantId(userDetails?.defaultParticipantId);
    }, [userDetails]);

    const validateAmountNotInDescription = (descCols: any, amtCol: any) => {
        if (!amtCol || !descCols?.length) {
            setAmountColumnError("");
            return;
        }
        const match = descCols.some((desc: any) => desc.name === amtCol);
        if (match) {
            setAmountColumnError(translate('amountColumnShouldNotBeOneOfTheDescriptionColumns'));
        } else {
            setAmountColumnError("");
        }
        setMappingDetailsFlag(true);
    };

    useEffect(() => {
        if (AdminProfile.participantAdminProfile === constants.ADMIN_VIEW) {
            getAllParticipantsList();
        }
    }, [AdminProfile]);

    async function getAllParticipantsList() {
        try {
            const ParticipantVo = { participantName: "", isActive: constants.IS_ACTIVE_YES };
            const responseList = await getAllParticipants(ParticipantVo);
            if (responseList.status === constants.STATUS_CODES.SUCCESS) {
                const participants = responseList.data.data.map((p: any) => ({
                    participantId: p.participantId,
                    participantName: p.participantName,
                }));
                const updatedParticipants = [{ participantId: 0, participantName: constants.SELECT_PLACEHOLDER }, ...participants];
                setParticipantArray(updatedParticipants);
            } else {
                setParticipantArray([]);
            }

        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }
    const validateBeforeUpload = () => {
        let shouldDisable = false;
        let errors = {
            yearError: false,
            periodError: false,
            monthError: false,
            quarterError: false,
            semiannuallyError: false,
            yearlyTypeError: false
        };


        if (!period?.value || !year) {
            shouldDisable = true;
            errors.periodError = true;
            errors.yearError = !year;
        }
        switch (period?.value) {
            case "MONTHLY":
                if (!month) {
                    shouldDisable = true;
                    errors.monthError = true;
                }
                break;
            case "QUARTERLY":
                if (!quarter) {
                    shouldDisable = true;
                    errors.quarterError = true;
                }
                break;
            case "SEMIANNUALLY":
                if (!semiannually) {
                    shouldDisable = true;
                    errors.semiannuallyError = true;
                }
                break;
            case "YEARLY":
                if (!yearlyType) {
                    shouldDisable = true;
                    errors.yearlyTypeError = true;
                }
                break;
            default:
                shouldDisable = true;
                errors.periodError = true;
        }
        setPeriodError(errors.periodError);
        setYearError(errors.yearError);
        setMonthError(errors.monthError);
        setQuarterError(errors.quarterError);
        setSemiannuallyError(errors.semiannuallyError);
        setYearlyTypeError(errors.yearlyTypeError);

        setIsDisabled(shouldDisable);
        return !shouldDisable;
    };

    const handleFilesSelected = (files: File[]) => {
        if (!files || files.length === 0) return;

        const file = files[0];
        const fileName = file.name.toLowerCase();
        if (!(fileName.endsWith(".xls") || fileName.endsWith(".xlsx") || fileName.endsWith(".csv"))) {
            setFileErrorMessage(translate('OnlyXlsXlsxOrCscFilesAreAllowed'));
            setFile([]);
            setSelectedFile("");
            setFileChanged(false);
            return;
        }
        if (file.size === 0) {
            setFileErrorMessage(translate('pleaseSelectAValidFileTheFileSizeIsZeroBytes'));
            setFile([]);
            setSelectedFile("");
            setFileChanged(false);
            return;
        }
        dispatch(resetImportDataDetails());
        setAmountColumnError("");
        setFileErrorMessage("");
        const isValid = validateBeforeUpload();
        if (!isValid) return;

        setFile(file);
        setSelectedFile(file.name);
        setFileChanged(true);
    };

    useEffect(() => {
        const processFile = async () => {
            if (file && fileChanged) {
                setSelectedFile(file.name);
                setAmountColumnError("");
                setTransformedImport([]);

                const reader = new FileReader();

                reader.onload = async (e) => {
                    if (!e.target?.result) return;

                    const data = new Uint8Array(e.target.result as ArrayBuffer);
                    const workbook = XLSX.read(data, { type: "array" });

                    if (workbook.SheetNames.length > 1) {
                        setSheets(workbook.SheetNames);
                        setAmountColumn("");
                        setDescriptionColumn([]);
                    } else {
                        setSheets([]);
                        const excelData = await readExcel(workbook, 0);
                        setSelectSheet("");

                        if (excelData) {
                            await getParticipantFileMappingByParticipantIdInfo(
                                excelData.dropdownItems,
                                excelData.extractedKeys
                            );
                        }

                        setFileChanged(false);
                    }
                };

                reader.readAsArrayBuffer(file);
            }
        };

        processFile();
    }, [file && fileChanged]);

    const handleSheetChange = (sheetIndex: number, sheetName: string | null) => {
        if (!file || typeof file !== 'object' || !(file instanceof Blob)) {
            return;
        }
        const reader = new FileReader();

        reader.onload = async (e) => {
            if (!e.target?.result) return;
            const data = new Uint8Array(e.target.result as ArrayBuffer);
            const workbook = XLSX.read(data, { type: "array" });
            const excelData = await readExcel(workbook, sheetIndex);

            if (excelData) {
                await getParticipantFileMappingByParticipantIdInfo(
                    excelData.dropdownItems,
                    excelData.extractedKeys
                );
            }

            setFileChanged(false);
        };
        reader.readAsArrayBuffer(file);
    };
    const readExcel = async (wb: XLSX.WorkBook, sheetNumber: number) => {
        setIsLoading(true);
        setLoadingFlag(true);
        const wsName: string = wb.SheetNames[sheetNumber];
        const ws: XLSX.WorkSheet = wb.Sheets[wsName];

        if (!ws || !ws["!ref"]) {
            setIsLoading(false);
            setLoadingFlag(false);
            if (wb.SheetNames.length > 1) {
                            notifyUser("Selected file sheet has no data", "error", "Actuals Import");
                        } else {
                            notifyUser("Selected file has no data", "error", "Actuals Import");
                        }
            return null;
        }
        const range = XLSX.utils.decode_range(ws["!ref"]);

        if (range.e.r <= range.s.r) {
            setIsLoading(false);
            setLoadingFlag(false);
            notifyUser("File does not contain valid data rows", "error", "Actuals Import");
            return null;
        }
        const extractedData: any[] = [];
        const dropdownItems: { id: number; name: string }[] = [];
        const extractedKeys: string[] = [];

        for (let rowIndex = range.s.r; rowIndex <= range.e.r; rowIndex++) {
            let rowData: Record<string, any> = {};
            for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex++) {
                const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                const cell = ws[cellAddress];
                const columnKey = `Column ${columnName[colIndex]}`;
                if (cell && cell.f) {
                    const regex = /^[0-9]/;
                    rowData[columnKey] = regex.test(cell.f) ? cell.f : "";
                } else if (cell?.v !== undefined && cell?.v !== null && cell?.v !== "") {
                    rowData[columnKey] = cell.v;
                } else {
                    rowData[columnKey] = "";
                }
                if (rowIndex === 0) {
                    dropdownItems.push({ id: colIndex + 1, name: columnKey });
                    extractedKeys.push(columnKey);
                }
            }
            extractedData.push(rowData);
        }
        const hasData = extractedData.slice(1).some(row =>
            Object.values(row).some(val => val !== "")
        );

        if (!hasData) {
            setIsLoading(false);
            setLoadingFlag(false);
            notifyUser("File contains only empty rows", "error", "Actuals Import");
            return null;
        }
        setRowData(extractedData);
        setDescriptionColumnList(dropdownItems);
        setAmountColumnList(extractedKeys);
        setIsLoading(false);
        setLoadingFlag(false);
        return {
            dropdownItems,
            extractedKeys
        };
    };
    async function getParticipantFileMappingByParticipantIdInfo(
        descriptionColumnListParam: { id: number; name: string }[],
        amountColumnListParam: string[]
    ) {
        setLoadingFlag(true);
        try {
            let formate;

            formate = yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES ? constants.YEARLY_TYPE_MONTHLY_VALUES_MONTHLY : constants.YEARLY_TYPE_ANNUAL;

            const responseList = await getParticipantFileMappingByParticipantIdType(
                participantId,
                constants.TYPE_ACTUAL,
                formate,
                userDetails.clientId
            );

            if (
                responseList?.status === constants.STATUS_CODES.SUCCESS &&
                responseList?.data?.data?.participantsFileColumnMappingsVOList?.length > 0
            ) {
                const mappingVO = responseList.data.data.participantsFileColumnMappingsVOList[0];

                setFileColumnMappingId(mappingVO?.id);
                setVersion(mappingVO?.version);
                dispatch(
                    setImportDataDetails({
                        ...importData,
                        fileColumnMappingDetailes: mappingVO,
                    })
                );
                const columns = mappingVO.descriptionColumns
                    .split(",")
                    .map((name: string) => name.trim());

                const fetchedItems = descriptionColumnListParam.filter(item =>
                    columns.includes(item.name)
                );

                setDescriptionColumn(fetchedItems);

                const selectedMonth = amountColumnListParam.find(
                    a => a === mappingVO.amountColumn
                );

                setAmountColumn(selectedMonth || "");
            } else {
                setMappingDetailsFlag(true);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingFlag(false);
            await getMapList();
        }
    }

    async function getMapList() {
        setLoadingFlag(true);
        try {
            const responseList = await getForecastMappingDetailsByFinancialYearsAndParticipantId(participantId, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                setForecastMappingDetails(responseList.data.data.fiscalExternalAccountSystemVOList);
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        } finally {
            setLoadingFlag(false);
        }
    }

    const handleCancel = () => {
        setOpenPopUp(true);
    };
    const handlePopUpClose = () => {
        setOpenPopUp(false);
        setOpenMappingDetailsPopUp(false);
        dispatch(setImportDataDetails({ isInitialRender: false }));
    };
    function handleConfirm() {
        navigate("/actualsListing");
    }

    const getAmountValuesForItem = (item: any, monthIndex?: number) => {
        const isMonthlyValues = period?.value === "YEARLY" && yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES;

        if (isMonthlyValues && monthIndex !== undefined) {
            // For monthly values, get the specific column for this month
            const columnName = amounts[String(monthIndex + 1)];
            if (!columnName) return null;
            const rawValue = item[columnName];
            return rawValue === undefined || rawValue === null || rawValue === "" ? null : rawValue;
        } else if (!isMonthlyValues) {
            // For all other cases, use the single amount column
            const rawValue = item[amountColumn];
            return rawValue === undefined || rawValue === null || rawValue === "" ? null : rawValue;
        }
        return null;
    };

    // Updated getAmountAndPerMonth function
    const getAmountAndPerMonth = (item: any): { amount: string; monthlyAmounts: string[] } => {
        const isMonthlyValues = period?.value === "YEARLY" && yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES;

        if (isMonthlyValues) {
            const monthlyAmounts: number[] = [];
            let totalAmount = 0;

            for (let i = 0; i < monthCount; i++) {
                const rawValue = getAmountValuesForItem(item, i);
                const parsedValue = rawValue ? parseFloat(rawValue.toString().replace(/[^0-9.-]/g, "")) : 0;
                const validValue = !isNaN(parsedValue) ? parsedValue : 0;
                monthlyAmounts.push(validValue);
                totalAmount += validValue;
            }

            return {
                amount: formatCurrency(totalAmount),
                monthlyAmounts: monthlyAmounts.map(a => formatCurrencywithoutDoller(a))
            };
        } else {
            const rawAmount = getAmountValuesForItem(item);
            const parsedAmount = rawAmount ? parseFloat(rawAmount.toString().replace(/[^0-9.-]/g, "")) : 0;
            const finalAmount = !isNaN(parsedAmount) ? parsedAmount : 0;

            if (!isFinite(finalAmount) || monthCount <= 0) {
                return { amount: formatCurrency(0), monthlyAmounts: Array(monthCount).fill(formatCurrencywithoutDoller(0)) };
            }

            const perMonth = +(finalAmount / monthCount).toFixed(2);
            const totalAssigned = +(perMonth * monthCount).toFixed(2);
            const remainder = +(finalAmount - totalAssigned).toFixed(2);

            const monthlyAmounts = Array(monthCount).fill(perMonth);
            if (remainder !== 0) {
                monthlyAmounts[monthCount - 1] += remainder;
            }

            return {
                amount: formatCurrency(finalAmount),
                monthlyAmounts: monthlyAmounts.map(a => formatCurrencywithoutDoller(a))
            };
        }
    };

    useEffect(() => {
        if (period?.value !== constants.PERIOD_YEARLY || yearlyType?.value !== constants.YEARLY_TYPE_MONTHLY_VALUES) return;

        const newErrors: { [key: string]: string } = {};

        for (let i = 1; i <= 12; i++) {
            const key = String(i);
            const value = amounts[key];

            if (!value || value.trim() === "") {
                newErrors[key] = translate('pleaseSelectAValidAmountColumn');
            } else {
                const isConflict = descriptionColumn.some((desc: any) => desc.name === value);
                if (isConflict) {
                    newErrors[key] = translate('amountColumnShouldNotBeOneOfTheDescriptionColumns');
                }
            }
        }

        setAmountColumnErrors(newErrors);
    }, [amounts, descriptionColumn, period, yearlyType, selectSheet]);


    useEffect(() => {
        if (!rowData || rowData.length === 0) return;
        if (!descriptionColumn || descriptionColumn.length === 0) return;

        const isMonthlyValues = period?.value === "YEARLY" && yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES;
        if (isMonthlyValues) {
            if (!amounts || Object.keys(amounts).length === 0) return;
        } else {
            if (!amountColumn || amountColumn.trim() === "") return;
        }

        const transformed = rowData.map((item: any, index: number) => {
            if (index === 0) return null;

            const sortedDescriptionColumns = descriptionColumnList.filter(option =>
                descriptionColumn.some(selected => selected.name === option.name)
            );

            const locationGL = sortedDescriptionColumns
                ?.map(col => item?.[col.name]?.toString()?.trim() || "")
                .filter(val => val && val !== "Description")
                .join(" ")
                .replace(/\s+/g, " ")
                .trim();

            let isAmountValid = false;

            if (isMonthlyValues) {
                isAmountValid = filteredMonthsList.some((_, i) => {
                    const rawValue = getAmountValuesForItem(item, i);
                    if (!rawValue) return false;
                    const parsedValue = parseFloat((rawValue ?? "").toString().replace(/[^0-9.-]/g, ""));
                    return !isNaN(parsedValue);

                });
            } else {
                const rawValue = getAmountValuesForItem(item);
                if (rawValue !== null && rawValue !== undefined && rawValue !== "") {
                    const parsedValue = parseFloat((rawValue ?? "").toString().replace(/[^0-9.-]/g, ""));
                    isAmountValid = !isNaN(parsedValue);
                }
            }

            if (!locationGL || !isAmountValid) {
                return null;
            }

            const { amount, monthlyAmounts } = getAmountAndPerMonth(item);

            // Diocese GL mapping logic (unchanged)
            let dioceseGLMapping = null;

            const normalize = (str: string) =>
                str?.toString().replace(/\s+/g, " ").trim();
            const forecastMatch = forecastMappingDetails?.find((mapping: any) => {
                const matchedChart = standardChartList?.find((chart: any) =>
                    chart.subChartAccountNumber === mapping.accountNumber &&
                    normalize(mapping.description) === normalize(locationGL)
                );
                if (matchedChart) {
                    dioceseGLMapping = matchedChart;
                    return true;
                }
                return false;
            });

            const monthlyAmountsMap = filteredMonthsList?.reduce((acc: Record<string, string>, month, i) => {
                acc[month] = monthlyAmounts[i] ?? formatCurrencywithoutDoller(0);
                return acc;
            }, {});

            return {
                locationGL,
                amount,
                dioceseGLMapping,
                ...monthlyAmountsMap,
            };
        }).filter(row => row !== null);

        if (importData?.isInitialRender) {
            setTimeout(() => {
                setTransformedImport(importData?.transformedImport);
                dispatch(setImportDataDetails({ isInitialRender: false }));
            }, 4000);
        } else {
            setTransformedImport(transformed);
        }
    }, [importData?.isInitialRender, rowData, descriptionColumn, amountColumn, monthCount, forecastMappingDetails, standardChartList, period, yearlyType, amounts, selectSheet, filteredMonthsList]);


    useEffect(() => {
        if (!mappingDetailsFlag) {
            const updated = transformedImport.map((row, index) => {
                const item = rowData[index];
                if (!item) return null;

                const sortedDescriptionColumns = descriptionColumnList.filter(option =>
                    descriptionColumn.some(selected => selected.name === option.name)
                );

                const locationGL = sortedDescriptionColumns
                    ?.map(col => item?.[col.name]?.toString()?.trim() || "")
                    .filter(val => val && val !== "Description")
                    .join(" ")
                    .replace(/\s+/g, " ")
                    .trim();

                const isMonthlyValues = period?.value === "YEARLY" && yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES;
                let isAmountValid = false;

                if (isMonthlyValues) {
                    isAmountValid = filteredMonthsList.some((_, i) => {
                        const rawValue = getAmountValuesForItem(item, i);
                        if (!rawValue) return false;
                        const parsedValue = parseFloat((rawValue ?? "").toString().replace(/[^0-9.-]/g, ""));
                        return !isNaN(parsedValue);
                    });
                } else {
                    const rawValue = getAmountValuesForItem(item);
                    if (rawValue !== null && rawValue !== undefined && rawValue !== "") {
                        const parsedValue = parseFloat((rawValue ?? "").toString().replace(/[^0-9.-]/g, ""));
                        isAmountValid = !isNaN(parsedValue);
                    }
                }

                if (!locationGL || !isAmountValid) {
                    return null;
                }

                const updatedRow = {
                    ...row,
                    locationGL,
                    dioceseGLMapping: row?.dioceseGLMapping ?? null,
                };

                if (isMonthlyValues || amountColumn) {
                    const { amount, monthlyAmounts } = getAmountAndPerMonth(item);
                    updatedRow.amount = amount;

                    filteredMonthsList?.forEach((month, i) => {
                        updatedRow[month] = monthlyAmounts[i] ?? formatCurrencywithoutDoller(0);
                    });
                }

                return updatedRow;
            }).filter(row => row !== null);
            setTransformedImport(updated);
        }
    }, [descriptionColumn, amountColumn, amounts]);



    useEffect(() => {
        if (participantId && year) {
            getForecastMappingDetailsByFinancialYearAndParticipantIdInfo();
        }
    }, [participantId, year]);
    async function getForecastMappingDetailsByFinancialYearAndParticipantIdInfo() {
        setLoadingFlag(true);
        try {
            const responseList = await getForecastMappingDetailsByFinancialYearAndParticipantId(year, participantId, constants.TYPE_ACTUALS, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                setStandardChartList(responseList?.data?.data?.importChartAccountsMappingVOList[0]?.standardChartAccountsVOList);
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        } finally {
            setLoadingFlag(false);
        }
    }
    useEffect(() => {
        if (participantId) {
            getBudgetForecastEligibleYearInfo();
        }
    }, [participantId]);



    async function getBudgetForecastEligibleYearInfo() {
        try {
            const responseList = await getBudgetActualEligibleMonthsByParticipantId(participantId, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                const eligibleList = responseList?.data?.data?.eligibleYearAndMonthsResponseList;
                setEligibleList(responseList?.data?.data?.eligibleYearAndMonthsResponseList)
                const years = eligibleList?.map((item: { year: number }) => item.year) ?? [];
                setBudgetYearsList(years);
            }

        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }

    useEffect(() => {

        if (!year || eligibleList.length === 0) return;
        const yearData = eligibleList?.find(item => item.year === year);
        if (!yearData) return;
        const readOnlyFalseMonths = yearData.eligibleMonthsList
            .filter((month: any) => !month.readOnly)
            .map((month: any) => month.month);

        setAvailableMonths(readOnlyFalseMonths);

        const newPeriodList = [{ value: constants.SELECT_PLACEHOLDER, name: constants.SELECT_PLACEHOLDER }];
        if (readOnlyFalseMonths.length > 0) {
            newPeriodList.push({ value: "MONTHLY", name: "Monthly" });
        }
        if (isQuarterlyAvailable(readOnlyFalseMonths)) {
            newPeriodList.push({ value: "QUARTERLY", name: "Quarterly" });
        }
        if (isSemiAnnuallyAvailable(readOnlyFalseMonths)) {
            newPeriodList.push({ value: "SEMIANNUALLY", name: "Semi-annually" });
        }
        if (isAnnuallyAvailable(readOnlyFalseMonths)) {
            newPeriodList.push({ value: "YEARLY", name: "Yearly" });
        }

        setPeriods(newPeriodList);
        setFilteredQuarters(
            quarters.filter((quarter: any) =>
                getQuarterMonths(quarter.value).every((m: any) => readOnlyFalseMonths.includes(m))
            )
        );

        setFilteredSemiannuallys(semiannuallys.filter((sa: any) => getSemiAnnuallyMonths(sa.value).every((m: any) => readOnlyFalseMonths.includes(m))));

        setFilteredYearlyTypes(isAnnuallyAvailable(readOnlyFalseMonths) ? yearlyTypes ?? [] : [])
    }, [year, eligibleList]);

    function isQuarterlyAvailable(months: string[]): boolean {
        const monthList = CommonUtilities.monthOrderUppercaseList;
        const quarters = [
            monthList.slice(0, 3),
            monthList.slice(3, 6),
            monthList.slice(6, 9),
            monthList.slice(9, 12),
        ];
        return quarters.some(q => q.every(month => months.includes(month)));
    }

    function isSemiAnnuallyAvailable(months: string[]): boolean {
        const monthList = CommonUtilities.monthOrderUppercaseList;

        const firstHalf = monthList.slice(0, 6);
        const secondHalf = monthList.slice(6, 12);

        return firstHalf.every(m => months.includes(m)) || secondHalf.every(m => months.includes(m));
    }

    function isAnnuallyAvailable(months: string[]): boolean {
        const fullYear = CommonUtilities.monthOrderUppercaseList;
        return fullYear.every(m => months.includes(m));
    }

    function getQuarterMonths(value: string): string[] {
        const monthList = CommonUtilities.monthOrderUppercaseList;

        const quarters: Record<string, string[]> = {
            Q1: monthList.slice(0, 3),
            Q2: monthList.slice(3, 6),
            Q3: monthList.slice(6, 9),
            Q4: monthList.slice(9, 12),
        };
        return quarters[value] || [];
    }

    function getSemiAnnuallyMonths(value: string): string[] {
        const monthList = CommonUtilities.monthOrderUppercaseList;

        const semiAnnuals: Record<string, string[]> = {
            SA1: monthList.slice(0, 6),
            SA2: monthList.slice(6, 12),
        };

        return semiAnnuals[value] || [];
    }

    return (
        <StyledParentContainer>
            <StyledOneChildContainer>
                <StyledTwoChildContainer sx={{ border: "none" }}>
                    <SectionTitle> {translate('actualsImport')} </SectionTitle>
                    <Grid container spacing={2} sx={{ m: 2 }} direction={'column'} >
                        {AdminProfile.participantAdminProfile === constants.ADMIN_VIEW && (
                            <Grid size={{ xs: 12, sm: 6, lg: 4 }} spacing={2}>
                                <CustomAutocomplete
                                    labelText={translate('participantName')}
                                    required
                                    size='small'
                                    options={participantArray || []}
                                    value={selectedParticipant}
                                    onChange={(event, newValue) => {
                                        setSelectedParticipant(newValue ?? { participantId: 0, participantName: constants.SELECT_PLACEHOLDER });
                                        setParticipantId(newValue?.participantId ?? 0);
                                        setYear("");
                                        setPeriod(null);
                                        setMonth(null);
                                        setQuarter(null);
                                        setSemiannually(null);
                                        setYearlyType(null);
                                        setDescriptionColumn([]);
                                        setTransformedImport([]);
                                        setRowData([]);
                                        setAmountColumn("");
                                        setAmounts({});
                                        setSelectSheet("");
                                        setSelectedFile("");
                                    }}
                                    getOptionLabel={(option) => option.participantName}
                                    isOptionEqualToValue={(option, value) => option.participantId === value?.participantId}
                                    placeholder={translate('participantName')}
                                    error={!selectedParticipant}
                                />
                            </Grid>
                        )}

                        <Grid size={{ xs: 12, sm: 6, lg: 4 }} >
                            <CustomAutocomplete
                                labelText={translate('budgetYear')}
                                required
                                size='small'
                                id="budget-year"
                                options={budgetYearsList ?? []}
                                value={year}
                                onChange={(event, newValue) => {
                                    setYear(newValue ?? "");
                                    setIsDisabled(year === "" || !newValue);
                                    setSelectSheet("");
                                    handleSheetChange(0, "");
                                    setPeriod(null);
                                    setMonth(null);
                                    setQuarter(null);
                                    setSemiannually(null);
                                    setYearlyType(null);
                                    setDescriptionColumn([]);
                                    setTransformedImport([]);
                                    setRowData([]);
                                    setAmountColumn("");
                                    setAmounts({});
                                    setSelectSheet("");
                                    setSelectedFile("");
                                }}
                                getOptionLabel={(option) => option}
                                placeholder={translate('budgetYear')}
                                error={yearError}
                            />
                            {yearError && (
                                <FormHelperText error>{translate('pleaseSelectaValidYear')} </FormHelperText>
                            )}
                        </Grid>


                        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                            <CustomAutocomplete
                                labelText={translate('period')}
                                required
                                size='small'
                                options={periods}
                                value={period}
                                onChange={(event, newValue) => {
                                    setPeriod(newValue);
                                    setMonth(null);
                                    setQuarter(null);
                                    setSemiannually(null);
                                    setYearlyType(null);
                                    setDescriptionColumn([]);
                                    setTransformedImport([]);
                                    setRowData([]);
                                    setAmountColumn("");
                                    setAmounts({});
                                    setSelectSheet("");
                                    setSelectedFile("");
                                }}
                                getOptionLabel={(option) => option.name}
                                placeholder={translate('period')}
                                error={periodError}
                            />
                            {periodError && (
                                <FormHelperText error>{translate('pleaseSelectaValidPeriod')}</FormHelperText>
                            )}
                        </Grid>

                        {period?.value === constants.PERIOD_MONTHLY && (
                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                <CustomAutocomplete
                                    labelText={translate('months')}
                                    required
                                    size='small'
                                    options={months.filter((monthObj) =>
                                        availableMonths.includes(monthObj.value.toUpperCase())
                                    )}
                                    value={month}
                                    onChange={(event, newValue) => {
                                        setMonth(newValue)

                                        setQuarter(null);
                                        setSemiannually(null);
                                        setYearlyType(null);
                                        setDescriptionColumn([]);
                                        setTransformedImport([]);
                                        setRowData([]);
                                        setAmountColumn("");
                                        setSelectSheet("");
                                        setSelectedFile("");
                                        dispatch(resetImportDataDetails());
                                    }}
                                    getOptionLabel={(option) => option.name}
                                    placeholder={translate('months')}
                                    error={monthError}
                                />
                                {monthError && (
                                    <FormHelperText error>{translate('pleaseSelectaValidMonth')}</FormHelperText>
                                )}
                            </Grid>
                        )}

                        {period?.value === constants.PERIOD_QUARTERLY && (
                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                <CustomAutocomplete
                                    labelText={translate('quarter')}
                                    required
                                    size='small'
                                    options={filteredQuarters}
                                    value={quarter}
                                    onChange={(event, newValue) => {
                                        setQuarter(newValue)
                                        setMonth(null);
                                        setSemiannually(null);
                                        setYearlyType(null);
                                        setDescriptionColumn([]);
                                        setTransformedImport([]);
                                        setRowData([]);
                                        setAmountColumn("");
                                        setSelectSheet("");
                                        setSelectedFile("");
                                    }}
                                    getOptionLabel={(option) => option.name}
                                    placeholder={translate('quarter')}
                                    error={quarterError}
                                />
                                {quarterError && (
                                    <FormHelperText error>{translate('pleaseSelectaValidQuarter')}</FormHelperText>
                                )}
                            </Grid>
                        )}

                        {period?.value === constants.PERIOD_SEMIANNUALLY && (
                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                <CustomAutocomplete
                                    labelText={translate('semiAnnually')}
                                    required
                                    size='small'
                                    options={filteredSemiannuallys}
                                    value={semiannually}
                                    onChange={(event, newValue) => {
                                        setSemiannually(newValue)
                                        setQuarter(null);
                                        setMonth(null);
                                        setYearlyType(null);
                                        setDescriptionColumn([]);
                                        setTransformedImport([]);
                                        setRowData([]);
                                        setAmountColumn("");
                                        setSelectSheet("");
                                        setSelectedFile("");
                                    }}
                                    getOptionLabel={(option) => option.name}
                                    placeholder={translate('semiAnnually')}
                                    error={semiannuallyError}
                                />
                                {semiannuallyError && (
                                    <FormHelperText error>{translate('pleaseSelectaValidSemiannually')}</FormHelperText>
                                )}
                            </Grid>
                        )}

                        {period?.value === constants.PERIOD_YEARLY && (
                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                <CustomAutocomplete
                                    labelText={translate('type')}
                                    required
                                    size='small'
                                    options={filteredYearlyTypes}
                                    value={yearlyType}
                                    onChange={(event, newValue) => {
                                        setYearlyType(newValue)
                                        setDescriptionColumn([]);
                                        setTransformedImport([]);
                                        setRowData([]);
                                        setAmountColumn("");
                                        setAmounts({});
                                        setSelectSheet("");
                                        setSelectedFile("");
                                        if (yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES) {
                                            setAmountColumnErrors((prevErrors) => ({
                                                ...prevErrors,
                                                monthly_values: translate('pleaseSelectAValidAmountColumn')
                                            }));
                                        } else {
                                            setAmountColumnErrors({});
                                        }
                                    }}
                                    getOptionLabel={(option) => option.name}
                                    placeholder={translate('type')}
                                    error={yearlyTypeError}
                                />
                                {yearlyTypeError && (
                                    <FormHelperText error>{translate('pleaseSelectaValidYearlyType')}</FormHelperText>
                                )}
                            </Grid>
                        )}
                        <Grid size={{ xs: 12, sm: 9, lg: 12 }}>
                            <StyledInputLabel sx={{ fontSize: 18 }}>{translate('selectFile')} </StyledInputLabel>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, lg: 4 }}  >
                            <FileUpload onFilesSelected={handleFilesSelected} />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 9, lg: 12 }}>
                            {selectedFile && <StyledInputLabel sx={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }} > {translate('selectedFile')}: {selectedFile}</StyledInputLabel>}
                            {fileErrorMessage && (
                                <FormHelperText error>{fileErrorMessage}</FormHelperText>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 9, lg: 8 }}>
                            <SubSectionTitle  >{translate('columnMappingDetails')}</SubSectionTitle>
                        </Grid>

                        {selectedFile && sheets && sheets.length > 1 &&
                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                <CustomAutocomplete
                                    labelText={translate('selectSheet')}
                                    required
                                    size='small'
                                    options={sheets}
                                    value={selectSheet}
                                    onChange={(event, newValue) => {
                                        setSelectSheet(newValue ?? "");
                                        const idx = sheets.indexOf(newValue);
                                        handleSheetChange(idx !== -1 ? idx : 0, newValue ?? "");
                                        setDescriptionColumn([]);
                                        setAmountColumn("");
                                    }}
                                    getOptionLabel={(option) => option}
                                    placeholder="Select a Sheet"
                                />
                            </Grid>}
                        {selectedFile && <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                            <CustomAutocomplete
                                labelText={translate('selectDescriptionColumn')}
                                size="small"
                                multiple
                                options={mergedOptions}
                                value={
                                    descriptionColumn.length === descriptionColumnList.length
                                        ? [SELECT_ALL_OPTION, ...descriptionColumnList]
                                        : descriptionColumnList.filter(option =>
                                            descriptionColumn.some(selected => selected.name === option.name)
                                        )
                                }
                                onChange={(event, newValue) => {
                                    const isSelectAllInNewValue = newValue.some((item: any) => item.id === SELECT_ALL_OPTION.id);
                                    const selectedWithoutAll = newValue.filter((item: any) => item.id !== SELECT_ALL_OPTION.id);
                                    if (isSelectAllInNewValue && descriptionColumn.length !== descriptionColumnList.length) {
                                        setDescriptionColumn([...descriptionColumnList]);
                                        validateAmountNotInDescription(descriptionColumnList, amountColumn);
                                        return;
                                    }
                                    if (descriptionColumn.length === descriptionColumnList.length && !isSelectAllInNewValue) {
                                        setDescriptionColumn(selectedWithoutAll);
                                        validateAmountNotInDescription(selectedWithoutAll, amountColumn);
                                        return;
                                    }
                                    if (
                                        descriptionColumn.length === descriptionColumnList.length &&
                                        selectedWithoutAll.length === descriptionColumnList.length - 1
                                    ) {
                                        setDescriptionColumn(selectedWithoutAll);
                                        validateAmountNotInDescription(selectedWithoutAll, amountColumn);
                                        return;
                                    }
                                    if (selectedWithoutAll.length === descriptionColumnList.length) {
                                        setDescriptionColumn([...descriptionColumnList]);
                                        validateAmountNotInDescription(descriptionColumnList, amountColumn);
                                        return;
                                    }
                                    setDescriptionColumn(selectedWithoutAll);
                                    validateAmountNotInDescription(selectedWithoutAll, amountColumn);
                                }}


                                getOptionLabel={(option) => option.name}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                placeholder={descriptionColumn.length === 0 ? translate('selectDescriptionColumn') : ''}
                                renderOption={(props, option, { selected }) => {
                                    const isAllSelected = descriptionColumn.length === descriptionColumnList.length;
                                    const isCurrentSelectAll = option.id === SELECT_ALL_OPTION.id;

                                    return (
                                        <li {...props}>
                                            <Checkbox
                                                checked={isCurrentSelectAll ? isAllSelected : selected}
                                                indeterminate={isCurrentSelectAll && descriptionColumn.length > 0 && !isAllSelected}
                                                tabIndex={-1}
                                                disableRipple
                                            />
                                            <ListItemText primary={option.name} />
                                        </li>
                                    );
                                }}
                            />
                        </Grid>}
                        {selectedFile && yearlyType?.value !== constants.YEARLY_TYPE_MONTHLY_VALUES && <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                            <CustomAutocomplete
                                labelText={translate('selectAmountColumn')}
                                size='small'
                                options={[...amountColumnList]}
                                value={amountColumn || constants.SELECT_PLACEHOLDER}
                                onChange={(event, newValue) => {
                                    onchangeAmount(newValue === constants.SELECT_PLACEHOLDER ? "" : newValue ?? "");
                                    validateAmountNotInDescription(descriptionColumn, newValue ?? "");
                                }}
                                getOptionLabel={(option: string) => option}
                                placeholder={translate('selectAmountColumn')}
                                error={!!amountColumnError}
                                helperText={amountColumnError}
                            />
                        </Grid>}
                        {selectedFile && (period?.value === constants.PERIOD_YEARLY && yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES) &&
                            (<Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                <StyledInputLabel sx={{ marginTop: 2 }} shrink>Monthly Select Column</StyledInputLabel>
                                {monthOrderOptions.map((month) => (
                                    <Box key={month.id} sx={{ mb: 2 }}>
                                        <CustomAutocomplete
                                            labelText={month.name}
                                            options={["Select", ...amountColumnList]}
                                            value={amounts[month.id] || constants.SELECT_PLACEHOLDER}
                                            onChange={(event, newValue) =>
                                                handleAmountChange(month.id, newValue === constants.SELECT_PLACEHOLDER ? "" : newValue ?? "")
                                            }
                                            getOptionLabel={(option: string) => option}
                                            placeholder="Select"
                                            error={!!amountColumnErrors[month.id]}
                                            helperText={amountColumnErrors[month.id] || ""}
                                        />
                                    </Box>
                                ))}
                            </Grid>
                            )}
                    </Grid>
                    {selectedFile && rowData && !loadingFlag && ((period?.value === constants.PERIOD_YEARLY && yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES && Object.keys(amountColumnErrors).length === 0) || (period?.value !== constants.PERIOD_YEARLY) || (period?.value === constants.PERIOD_YEARLY && yearlyType?.value !== constants.YEARLY_TYPE_MONTHLY_VALUES)) &&
                        (<TableContainer sx={{ overflow: 'auto' }}>
                            <StyledTable
                                stickyHeader
                                aria-label="sticky table"
                                size="small"
                                sx={{
                                    [`& .${tableCellClasses.root}`]: {
                                        borderBottom: 'none',
                                        borderTop: 'none',
                                    },
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align} className="cellTask">
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isLoading ? (
                                        <TableRow>
                                            <TableCell align="center" colSpan={columns.length}>
                                                <div className="loading-container">
                                                    <CircularProgress />
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        transformedImport.map((row, index) => {
                                            if (!row.locationGL || row.locationGL.trim() === "") {
                                                return null;
                                            }
                                            return (
                                                <React.Fragment key={index}>
                                                    <TableRow sx={{ backgroundColor: index % 2 === 0 ? "#f1f3f4" : "#fff" }}>
                                                        {columns.map((column) => {
                                                            return (
                                                                <TableCell key={column.id} align={column.align} className="left-aligned-text">
                                                                    {column.id === "dioceseGLMapping" ? (
                                                                        <Autocomplete
                                                                            sx={{ width: { xs: "100%", sm: 250 } }}
                                                                            options={[defaultSelectOption, ...(standardChartList || [])]}
                                                                            value={row.dioceseGLMapping ?? defaultSelectOption}
                                                                            onChange={(event, newValue) => handleDioceseGLMappingChange(index, newValue)}
                                                                            getOptionLabel={(option) => option?.displayName ?? ""}
                                                                            isOptionEqualToValue={(option, value) =>
                                                                                option?.forecastSubChartId === value?.forecastSubChartId
                                                                            }
                                                                            renderInput={(params) => (
                                                                                <TextField {...params} placeholder={translate('glMapping')} size="small"
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        style: {
                                                                                            color: (row.dioceseGLMapping?.forecastSubChartId == null) ? 'red' : 'inherit',
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            renderOption={(props, option) => (
                                                                                <Box
                                                                                    component="li"
                                                                                    {...props}
                                                                                    sx={{
                                                                                        whiteSpace: 'normal',
                                                                                        wordBreak: 'break-word',
                                                                                        maxWidth: '500px',
                                                                                    }}
                                                                                    title={option.displayName}
                                                                                >
                                                                                    {option.displayName}
                                                                                </Box>
                                                                            )}
                                                                            PopperComponent={CustomPopper}
                                                                            slotProps={{
                                                                                popper: {
                                                                                    modifiers: [
                                                                                        { name: 'preventOverflow', options: { altAxis: true, tether: false, boundary: 'viewport' } },
                                                                                        { name: 'flip', options: { fallbackPlacements: ['left-start', 'left'] } },
                                                                                        { name: 'offset', options: { offset: [0, 8] } },
                                                                                    ],
                                                                                },
                                                                            }}
                                                                        />
                                                                    ) : column.id === "locationGL" ? (
                                                                        row.locationGL ?? "-"
                                                                    ) : column.id === "amount" ? (
                                                                        row.amount ?? "0.00"
                                                                    ) : CommonUtilities.monthRegularList.includes(column.id) ? (
                                                                        <Box position="relative" display="inline-block">
                                                                            <Box position="absolute" top={10} bgcolor="white" zIndex={1}>
                                                                                {" $ "}
                                                                            </Box>
                                                                            <Tooltip title={row[column.id as keyof typeof row] ?? ""} arrow placement="top">
                                                                                <Box display="inline-block" width="100%">
                                                                                    <CustomTextField
                                                                                        value={row[column.id as keyof typeof row] ?? ""}
                                                                                        onChange={(e) => handleForecastChange(column.id, e.target.value, index)}
                                                                                        onBlur={(e) => handleForecastBlur(column.id, e.target.value, index)}
                                                                                        inputProps={{
                                                                                            maxLength: 13,
                                                                                            style: { textAlign: "right", paddingLeft: 0, marginRight: 0.1 },
                                                                                        }}
                                                                                        sx={{ marginLeft: 0.5, pl: 0 }}
                                                                                    />
                                                                                </Box>
                                                                            </Tooltip>
                                                                        </Box>
                                                                    ) : (
                                                                        column.id
                                                                    )}
                                                                </TableCell>
                                                            );
                                                        })}
                                                    </TableRow>

                                                    {/* Expanded row content */}
                                                    <TableRow>
                                                        <TableCell colSpan={columns.length} sx={{ padding: 0, border: 'none' }}>
                                                            <Grid container spacing={2} sx={{ mx: 0.1 }}>
                                                                {/* Additional content goes here */}
                                                            </Grid>
                                                        </TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            );
                                        })

                                    )}

                                </TableBody>
                            </StyledTable>
                        </TableContainer>
                        )}

                    <Box className={basestyle.buttoncontainer} sx={{ mt: 3 }}>
                        <ContainedButton onClick={handleContinue} disabled={transformedImport.length === 0 || (period?.value === constants.PERIOD_YEARLY && yearlyType?.value === constants.YEARLY_TYPE_MONTHLY_VALUES && Object.keys(amountColumnErrors).length > 0)}>  {translate('continue')}  </ContainedButton>
                        <OutlinedButton onClick={handleCancel}>  {translate('cancel')}  </OutlinedButton>
                    </Box>
                    <CancelPopUp
                        open={openPopUp}
                        handleClose={handlePopUpClose}
                        saveChanges={() => handleConfirm()}
                        popupTitle={translate('confirmCancel')}
                        message={translate('doYouWantToCancelChanges?')}
                    />
                    <MappingDetailsWarningPopUp
                        open={openMappingDetailsPopUp}
                        handleClose={handlePopUpClose}
                        saveChanges={() => handleMappingDetailsConfirm()}
                        popupTitle={translate('mappingDetailsWarning')}
                        message={translate('doYouWantToMapTheSameMappingToOtherDescription?')}
                    />
                    <Backdrop
                        sx={{
                            color: "#fff",
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                            display: "flex",
                            flexDirection: "column",
                        }}
                        open={loadingFlag}
                    >
                        <CircularProgress color="inherit" />
                        <SubSectionTitle  >{translate('pleasewait')}</SubSectionTitle>
                    </Backdrop>
                </StyledTwoChildContainer>
            </StyledOneChildContainer>
        </StyledParentContainer>

    );
};
export default ActualsImport;